export default {
  toggleSideBar: ({ commit }) => commit('toggleSideBar'),
  toggleBpSelectionDialog: ({ commit }) => commit('toggleBpSelectionDialog'),
  toggleOverrideThemeForBpsDialog: ({ commit }) => commit('toggleOverrideThemeForBpsDialog')
};
